import type { Row } from '@tanstack/react-table';

import type { CharlieTableProps } from '../../charlie-table.types';

export const calculateRowPadding = <T extends object>(
	row: Row<T>,
	depthAddition: number,
	renderOptions?: CharlieTableProps<T>['renderOptions'],
): string => {
	const depthUnit = renderOptions?.expandableRow?.depthUnit ?? 8;
	const alignNonExpandable = renderOptions?.expandableRow?.alignNonExpandableRows ?? true;

	const basePadding = (row.depth + depthAddition) * depthUnit;
	const expandableWidth = 20;
	const rowPadding = !row.getCanExpand() && alignNonExpandable ? expandableWidth : 0;
	return `${basePadding + rowPadding}px`;
};
